
import { CollaborationPermission } from "@/types/collaboration";

export const canViewResponses = (permission: CollaborationPermission): boolean => {
  return ['view_responses', 'manage_recruitment', 'full_access'].includes(permission);
};

export const canManageRecruitment = (permission: CollaborationPermission): boolean => {
  return ['manage_recruitment', 'full_access'].includes(permission);
};

export const canManageTest = (permission: CollaborationPermission): boolean => {
  return permission === 'full_access';
};

export const getPermissionLabel = (permission: CollaborationPermission): string => {
  switch (permission) {
    case 'view_responses':
      return 'View Only';
    case 'manage_recruitment':
      return 'Manage Recruitment';
    case 'full_access':
      return 'Full Access';
    default:
      return 'Unknown';
  }
};
